"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _utils = require("@trs/utils");
var _misc = require("../../misc");
var _Icon = _interopRequireDefault(require("../../icon/Icon"));
var _helpers = require("./helpers");
var _StepperValueHeader = _interopRequireDefault(require("./StepperValueHeader.style"));
var _radio = require("../../radio");
var _helpers2 = require("../Templates/Share/helpers");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var StepperValueHeader = function StepperValueHeader(_ref) {
  var disabled = _ref.disabled,
    labels = _ref.labels,
    ruleIndex = _ref.ruleIndex,
    actions = _ref.actions,
    setHasChanges = _ref.setHasChanges,
    ruleChange = _ref.ruleChange,
    rule = _ref.rule;
  return /*#__PURE__*/_react["default"].createElement(_StepperValueHeader["default"], {
    ruleIndex: ruleIndex,
    "data-testid": "stepper-value-header"
  }, /*#__PURE__*/_react["default"].createElement(_misc.MenuList, {
    position: "top-right",
    disabled: disabled,
    menuItems: (0, _helpers.menuListItems)({
      labels: labels,
      actions: actions,
      ruleIndex: ruleIndex,
      setHasChanges: setHasChanges
    }),
    ignoreSingleItemLogic: true
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "ion-android-more-vertical"
  })), ruleIndex === 0 && /*#__PURE__*/_react["default"].createElement(_radio.RadioGroup, {
    className: "share-view-radiogroup",
    disabled: disabled,
    selectedValue: R.path(['stepper', 'activeType'], rule),
    options: (0, _helpers2.shareViewOptions)(labels),
    onChange: function onChange(event) {
      return ruleChange('stepper', (0, _helpers.onViewTypeChange)(event, rule));
    }
  }));
};
StepperValueHeader.defaultProps = {
  disabled: false,
  ruleChange: _utils.noop,
  rule: {}
};
StepperValueHeader.propTypes = {
  disabled: _propTypes["default"].bool,
  labels: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,
  ruleIndex: _propTypes["default"].number.isRequired,
  actions: _propTypes["default"].shape({
    deleteRuleBlock: _propTypes["default"].func
  }).isRequired,
  setHasChanges: _propTypes["default"].func.isRequired,
  ruleChange: _propTypes["default"].func,
  rule: _propTypes["default"].shape({})
};
var _default = exports["default"] = StepperValueHeader;